import React, { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Topbar from "../Global/topbar";
import TableBody2 from "../Table container/tablebody";
import CachedIcon from "@mui/icons-material/Cached";
import { getCallLogs } from "../../services/api/callLogs";
import { Context } from "../../context/contextapi";
import "../Audio Type/audio.css";

export default function CallLogs() {
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(true);
  const [data, setData] = useState(false);
  const [notfound, setNotFound] = useState(false);
  const [APIdata, setAPIdata] = useState([]);
  const [reload, setReload] = useState(true);
  const [skip, setSkip] = useState(0);
  const [limit, setLimit] = useState(5);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState("");
  const start_key = useRef({ 1: null });
  const page = useRef(1);
  const { setHasmore } = useContext(Context);
  const currentAudio = useRef(null);

  const fetchCallLogs = async () => {
    const paginationKey = start_key.current[page.current];
    getCallLogs(limit, paginationKey)
      .then((response) => {
        if (response?.data?.status === "success") {
          const result = response?.data?.data;
          if (result?.data?.length === 0) {
            setLoader(false);
            setNotFound(true);
            setData(true);
            setTotal(result?.total || 0);
            setHasmore(false);
          } else {
            setLoader(false);
            setNotFound(false);
            setData(true);
            setTotal(result?.total || 0);

            const mapped = (result?.data || []).map((item) => {
              const participants = item.participants || [];
              const userName =
                participants.find((p) => p?.entity === "user")?.name ||
                participants.find((p) => p?.id === item.user_id)?.name ||
                "-";
              const consultantName =
                participants.find((p) => p?.entity === "consultant")?.name ||
                participants.find((p) => p?.id === item.consultant_id)?.name ||
                "-";

              const dateStr = item.created_at
                ? new Date(item.created_at).toLocaleString("en-IN", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                : "-";

              return {
                ...item,
                user_name: userName,
                consultant_name: consultantName,
                date: dateStr,
              };
            });

            setAPIdata(mapped);
            start_key.current[page.current + 1] = result?.last_key || null;
            if (result?.last_key) {
              setHasmore(true);
            } else {
              setHasmore(false);
            }
            sessionStorage.setItem(
              "start_key",
              JSON.stringify(start_key.current)
            );
          }
        } else {
          setLoader(false);
          setHasmore(false);
          setNotFound(true);
        }
      })
      .catch(() => {
        setLoader(false);
        setNotFound(true);
        setHasmore(false);
      });
  };

  useEffect(() => {
    setAPIdata([]);
    setLoader(true);
    setNotFound(false);
    const delayDebounceFn = setTimeout(() => {
      fetchCallLogs();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [reload, skip, limit]);

  useEffect(() => {
    const start = JSON.parse(sessionStorage.getItem("start_key"));
    const URI = JSON.parse(sessionStorage.getItem("path"));
    if (start && location.pathname === URI) {
      start_key.current = start;
    } else {
      start_key.current = { 1: null };
    }
  }, [location]);

  const headers = [
    { topic: "#" },
    { topic: "User" },
    { topic: "Consultant" },
    { topic: "Status" },
    { topic: "Date" },
    { topic: "User Recording" },
    { topic: "Consultant Recording" },
    { topic: "Merged Recording" },
  ];

  const cell = [
    { topic: "user_name" },
    { topic: "consultant_name" },
    { topic: "call_status" },
    { topic: "date" },
    { topic: "user_recording_url" },
    { topic: "partner_recording_url" },
    { topic: "recording_url" },
  ];

  const handleReload = () => {
    setReload((prev) => !prev);
  };

  return (
    <div className="audio-main">
      <div className="audio-user-top">
        <Topbar />
        <div className="top-mid-audio">
          <h1>Call Logs</h1>
          <Link to="/admin/call_logs">Call Logs</Link> &#62;
        </div>
        <div className="tob-btm-audio">
          <div className="button-box-user"></div>
          <div>
            <button onClick={handleReload}>
              <CachedIcon />
            </button>
          </div>
        </div>
        <div className="table1">
          <TableBody2
            headers={headers}
            APIdata={APIdata}
            cell={cell}
            path="/admin/call_logs"
            loader={loader}
            notfound={notfound}
            data={data}
            menu={false}
            setReload={setReload}
            setSkip={setSkip}
            total={total}
            setLimit={setLimit}
            pages={pages}
            deleted={false}
            newPage={page}
            search={search}
            IsAction={false}
          />
        </div>
      </div>
    </div>
  );
}
